<template>
	<div
		class="productcard hover"
		:class="[{'inline' : inline}, {'card' : !inline}]"
		:data-price="product.price.value"
		:id="product.areaId"
		:name="product.name"
	>
		<div class="productcard__first">

			<!-- вывод стикеров -->
			<Citrus-Product-Stickers :list="product.stickers"></Citrus-Product-Stickers>
			<!-- вывод картинки -->
			<a :href="product.detail_page" :title="product.name" @click.stop.prevent="toDetailPage">
				<img class="productcard__first--image" v-if="product.preview" :src="product.preview" :alt="product.previewName" :title="product.previewTitle">
			</a>
			<!-- вывод контрол "Добавить в сравнение" -->
			<Citrus-Product-Compare :product="product.id" :icon="{id: 'icon-Compare'}" :storage="'vuex'" ></Citrus-Product-Compare>
			<!-- вывод контрол "Добавить в избранное" -->
			<Citrus-Product-Favorites :product="product.id" :icon="{id: 'icon-Favorites'}" ></Citrus-Product-Favorites>

			<a class="productcard__first--remove" href="#">
				<svg class="icon">
					<use :xlink:href="iconPath + '#icon-Cross'"></use>
				</svg>
				<span v-html="loc.PRODUCT_ITEM_REMOVE"></span>
			</a>

		</div>

		<div class="productcard__center">
			<a @click.stop.prevent="toDetailPage" :href="product.detail_page" class="productcard__center--title" v-html="product.name"></a>

			<Citrus-Product-Rating :href="product.detail_page" :rating="product.rating" :text="product.print_reviews"></Citrus-Product-Rating>

			<div
				class="productcard__center--article"
				v-if="product.article" v-html="loc.PRODUCT_ITEM_ARTICLE + product.article"
			></div>
			<div
				class="productcard__quantity--label"
				:class="{'__green': product.available, '__red': !product.available}"
				v-html="product.quantityLabel"
			></div>
		</div>

		<div class="productcard__bottom" v-if="!product.outProduction">
			<div class="productcard__bottom--label" v-if="!product.isInline">
				<div
					class="productcard__bottom__quantity--label"
					:class="{'__green': product.available, '__red': !product.available}"
					v-html="product.quantityLabel"
				></div>
				<div class="productcard__bottom__price-label __red" v-if="!product.available" v-html="product.priceLabel"></div>
			</div>

			<!-- вывод цены товара -->
			<Citrus-Product-Basket-Price
				v-if="product.price.full > 0"
				:price-label="product.priceLabel"
				:available="product.available"
				:base-price="product.price.full"
				:discount-price="product.price.price"
				:unitText="loc.PRODUCT_ITEM_UNIT + product.measure_name"
			></Citrus-Product-Basket-Price>

			<!-- вывод кнопку "Купить" -->
			<Citrus-Product-Basket-Button :product-id="product.id" v-if="product.price.full > 0"></Citrus-Product-Basket-Button>

			<!-- вывод кнопку "Купить в 1 клик" -->
			<Citrus-Product-Buy-On-Click v-if="product.available" :product-id="product.id" ></Citrus-Product-Buy-On-Click>
			<!-- вывод кнопку "Заказать" -->
			<Citrus-Product-Order-Click v-else :product-id="product.id" ></Citrus-Product-Order-Click>
		</div>
	</div>
</template>

<script>
/**
 * product item card Vue component
 *
 * @package citrus.vue.product.item
 */
import {Vue} from "ui.vue";

import 'citrus.vue.product.stickers';
import 'citrus.vue.product.favorites';
import 'citrus.vue.product.compare';
import 'citrus.vue.product.basket-button';
import 'citrus.vue.product.rating';
import 'citrus.vue.product.buyonclick';
import 'citrus.vue.product.orderclick';

import SITE_CONFIG from 'citrus.config';

Vue.filter('truncate', function (text, stop, clamp) {
	return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
});

export default {
	name: "CitrusProductItem",
	props: {
		product: {
			type: [Array, Object, Boolean],
			default: false,
		},
		inline: {
			type: [Boolean],
			default: false,
		},
	},
	data: function () {
		let data = {
			loading: false,
			showTechSpecs: false,
		};
		return data;
	},
	computed: {
		loc() {
			return Object.freeze(Vue.getFilteredPhrases("PRODUCT_ITEM_"));
		},
		shortProductName() {
			return this.$options.filters.truncate(this.product.name, 35, '...');
		},
		iconPath() {
			return SITE_CONFIG.SVG_PATH;
		},
		isInline() {
			return 'inline' === this.mode
		}
	},
	created: function () {
		Vue.event.$on("Citrus.Vue.Product:addedToBasket", (payload) => {
			if(payload.productId !== this.product.id)
			{
				return
			}

			console.log({
				"id": this.product.article ?? payload.productId,
				"name": this.product.name,
				"price": this.product.price.full ?? 0,
				"category": this.product.navChain,
				"quantity": payload.quantity ?? 1,
			})

			this.$metrika.push({
				"ecommerce": {
					"currencyCode": this.product.price.CURRENCY ?? "RUB",
					"add": {
						"products": [
							{
								"id": this.product.article ?? payload.productId,
								"name": this.product.name,
								"price": this.product.price.full ?? 0,
								"category": this.product.navChain,
								"quantity": payload.quantity ?? 1,
							}
						]
					}
				}
			})
		})
	},
	updated: function () {

	},
	methods: {
		toDetailPage: function () {
			const product = this.product
			this.$metrika.push({
				"ecommerce": {
					"currencyCode": product.price.currency ?? "RUB",
					"click": {
						"products": [
							{
								"id": product.article ?? product.productId,
								"brand": product.brandName,
								"name": product.name,
								"price": product.price.VALUE ?? 0,
								"category": product.navChain,
								"quantity": 1,
							}
						]
					}
				}
			});
			setTimeout(() => {
				window.location.href = this.product.detail_page
			}, 100)

		}
	},
	beforeDestroy() {
		Vue.event.$off("Citrus.Vue.Product:addedToBasket");
	},
};
</script>
